import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { uniqueId } from 'lodash';
import TitleTypography from '../../../MUI/TitleTypography';
import { bindTravelAdditionalCoverages } from '../../../../helpers/travel/travelCalcHelpers';

import useStyles from './makeStyles';

const ActiveCoverages = ({ selectedPlan }) => {
  const { t } = useTranslation();

  const classes = useStyles();

  const [expandCoverageId, setExpandCoverageId] = useState(null);
  const {
    travelDetails: { selectedCoverages },
  } = useSelector((state) => state.travelContract.contractData, shallowEqual);

  const planCoverages = useMemo(() => (
    bindTravelAdditionalCoverages(selectedPlan)
  ), [selectedPlan]);

  const activeCoverages = useMemo(
    () => planCoverages.reduce((acc, item) => {
      if (selectedCoverages[item.label]?.active) {
        return [...acc, item];
      }

      return acc;
    }, []),
    [planCoverages, selectedCoverages],
  );

  const handleClick = useCallback(
    (coverageId) => {
      if (coverageId === expandCoverageId) {
        setExpandCoverageId(null);
      } else {
        setExpandCoverageId(coverageId);
      }
    },
    [expandCoverageId],
  );

  if (!activeCoverages.length) {
    return <></>;
  }

  return (
    <>
      <TitleTypography className={classes.sectionTitle}>
        {t('travel.additionalCoverages')}
      </TitleTypography>
      {activeCoverages.map((coverage) => (
        <React.Fragment key={uniqueId()}>
          <Grid container wrap="nowrap" spacing={2} className={classes.rowItem}>
            <Grid item className={classes.icon} xs={1}>
              <img alt={coverage.label} src={coverage.icon} />
            </Grid>
            <Grid item xs={8}>
              <Typography className={classes.title}>
                {t(`travel.additionalCoverageTypes.data.${coverage.id}.name`)}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                onClick={() => handleClick(coverage.id)}
                align="right"
                className={classes.seeMore}
              >
                {expandCoverageId === coverage.id ? t('seeLess') : t('seeMore')}
              </Typography>
            </Grid>
          </Grid>
          {expandCoverageId === coverage.id && (
            <Grid container spacing={2}>
              <Grid item xs={1} />
              <Grid item xs={11} className={classes.description}>
                <Typography className={classes.coverageId}>
                  {t(`travel.additionalCoverageTypes.data.${coverage.id}.desc`)}
                </Typography>
              </Grid>
            </Grid>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

ActiveCoverages.propTypes = {
  selectedPlan: PropTypes.string.isRequired,
};

export default ActiveCoverages;
